module.exports = __webpack_public_path__ + "img/share-02.ce48f2fe.svg";